/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Zone from 'astro/server/zone';

import * as Coords from 'shared/geo/coords';
import * as Influence from 'astro/util/influence';


const MAX_ZONE_NEIGHBORS = 6;

export default class extends Zone
{
  constructor (cass, planet)
  {
    super(cass, planet);
  }


  install ()
  {
    if (this.getRedirectAttributes().getInfluenceDirections().length === 0)
    {
      this.installRingNeighbors();
    }
    else
    {
      this.installDirectionNeigbors();
    }
  }


  installRingNeighbors ()
  {
    const range = this.getRedirectAttributes().getInfluenceRange();

    for (const coords of Coords.getNeighborsInRing(this.getCass().getCoords(), range))
    {
      const neighbor = this.planet.getZones().getOne(coords.toString());

      if (neighbor != null && !this.getRedirectAttributes().isInfluenceDisabled(coords.toString()))
      {
        neighbor.getAttributes().installInfluence(this.makeNeighborInfluence());
      }
    }
  }


  installDirectionNeigbors ()
  {
    for (const direction of this.getRedirectAttributes().getInfluenceDirections())
    {
      const neighbor = this.planet.getZones().getOne(direction.id);

      if (neighbor != null && !this.getRedirectAttributes().isInfluenceDisabled(direction.id))
      {
        neighbor.getAttributes().installInfluence(this.makeNeighborInfluence());
      }
    }
  }


  makeNeighborInfluence ()
  {
    let strength = this.getRedirectAttributes().getInfluenceStrength();

    const directions = this.getRedirectAttributes().getInfluenceDirections();

    if (directions.length)
    {
      strength *= MAX_ZONE_NEIGHBORS / directions.length;
    }

    // TODO this will fail if interaction from another planet has redirected attributes! We will also not get the attrs anyway...
    return Influence.makeNeighbor(this.getRedirectAttributes().getInfluenceUser(), this.getLocation(), strength);
  }


  getRedirectAttributes ()
  {
    const redirect = this.getAttributes().getInfluenceRedirect();

    if (redirect == null)
    {
      return this.getAttributes();
    }

    // TODO this will fail if the redirect location is from another planet!
    return this.planet.getZones().getOne(redirect.id).getAttributes();
  }


  isLocal ()
  {
    return true;
  }


  isPlatform ()
  {
    return false;
  }


};
